<i18n
  src="@/locales/views/organization/certifications/basic_certifications_producers/list_producers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_field_certification.yml" lang="yaml"></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">{{ module_name }}</h1>
  </div>

  <template v-if="load_data_general">
    <div class="flex flex-row justify-between">
      <div class="panel-plain-label">
        <badge-default
          :label="
            total_number_producers + ' ' + $t('labels.total_number_producers')
          "
        />
      </div>
      <button
        v-if="total_number_producers > 0"
        type="button"
        @click.prevent="downloadReport()"
        class="btn-white"
      >
        <i
          :class="[
            'fa-solid',
            downloading_rep ? 'fa-sync fa-spin' : 'fa-file-excel',
          ]"
        ></i
        ><span class="space-icon"></span
        >{{ $t("labels.download_report_button") }}
      </button>
    </div>
    <div class="mt-4 flex flex-row-reverse gap-2">
      <white-button v-if="filtered" label="Limpiar" @click="clearFilters" />
      <white-button label="Filtrar" @click="filterProducers" />
      <input
        type="text"
        v-model.trim="filters.organization_crop_field_code"
        :placeholder="$t('model.producer.organization_crop_fields.crop_field_code')"
        class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
      />
      <input
        type="text"
        v-model.trim="filters.producer_code"
        :placeholder="$t('model.producer.producer_code')"
        class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
      />
      <input
        type="text"
        v-model.trim="filters.organization_producer_code"
        :placeholder="$t('model.producer.organization_producer.producer_code')"
        class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
      />
    </div>
    <div class="mt-8 flex flex-col">
      <ag-grid-vue
        style="width: 100%; height: 650px"
        class="ag-theme-alpine w-full h-full"
        :columnDefs="columnDefs"
        @grid-ready="onGridReady"
        :defaultColDef="defaultColDef"
        :rowData="columnsData"
      >
      </ag-grid-vue>
    </div>

    <letter-paginator v-if="load_data_general" v-show="!filtered" v-model="current_page" />
  </template>

  <loading-message v-else />

</template>

<script>
import moment from "moment";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import GoToLink from "@/components/views/layout/ag_grid/GoToLink.vue";
// import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import LetterPaginator from "@/components/views/layout/LetterPaginator.vue";
import LabelCertification from "@/components/views/organization/certifications/basic_certifications_producers/LabelCertification.vue";

import Requester from "@/views/organization/requesters/certifications/basic_certifications_producers/list_producers.js";
export default {
  name: "AECertificationsPartnersListProviders",
  components: { AgGridVue, LetterPaginator },
  data() {
    return {
      load_data_general: false,
      certifications: [],
      producer: [],
      current_page: "A",
      total_number_producers: 0,
      rows_per_page: 10,
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true,
      },
      columnDefs: [],
      downloading_rep: false,
      filters: {
        organization_crop_field_code: "",
        producer_code: "",
        organization_producer_code: ""
      },
      filtered: false
    };
  },
  props: { organization_id: { required: true } },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id,
        },
      }).then(() => this.loadData())
    );
  },
  computed: {
    columnsData() {
      let columns_data = [];
      for (let index = 0; index < this.producer.length; index++) {
        const producer = this.producer[index];
        const org_crop_fields = producer.organization_crop_fields;
        if (org_crop_fields.length == 0) {
          columns_data.push(this.parseProducer(producer));
        } else {
          org_crop_fields.forEach((org_crop_field) => {
            columns_data.push(this.parseProducer(producer, org_crop_field));
          });
        }
      }

      return columns_data;
    },
    can_filter() {
      return Object.values(this.filters).some(f => f !== "");
    }
  },
  watch: {
    current_page: function () {
      if (!this.filtered) {
        this.fetchProducers();
      }
    }
  },
  methods: {
    downloadReport: async function () {
      this.downloading_rep = true;
      try {
        var response = await Requester.downloadReport(
          this.organization_id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "certificaciones.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading_rep = false;
    },
    parseProducer: function (producer, org_crop_field = null) {
      let crop_field = null;
      if (org_crop_field) crop_field = org_crop_field.crop_field;
      let field_certifications = {};
      if (crop_field) {
        this.certifications.forEach((certification) => {
          field_certifications[`${certification.id}`] = this.certificationLabel(
            crop_field.crop_field_certifications,
            certification.id
          );
        });
      }
      return {
        id: producer.id,
        name: producer.name,
        lastname: producer.lastname,
        producer_code: producer.producer_code,
        organization_producer_code:
          producer.organization_producer.producer_code,
        crop_field: org_crop_field?.crop_field_code,
        ...field_certifications,
        route: this.routeName("show_producer"),
        route_params: {
          organization_id: this.organization_id,
          producer_id: producer.id,
        },
      };
    },
    loadData: async function () {
      await this.fetchCertifications();
      await this.fetchProducers();
      this.fillColumnsDef();
      this.load_data_general = true;
    },
    fetchCertifications: async function () {
      let response = await Requester.fetchCertifications(this.organization_id);

      this.certifications = response.data;
    },
    fetchProducers: async function () {
      let response;
      response = await Requester.fetchProducers(
        this.organization_id,
        this.current_page,
      );
      this.total_number_producers = response.data.total;
      this.producer = response.data.producers || response.data;
    },
    filterProducers: async function () {
      if (!this.filtering && this.can_filter) {
        let response = await Requester.filterProducers(
          this.organization_id,
          this.filters
        );
        this.producer = response.data;
        this.filtered = true;
      }
    },
    clearFilters() {
      this.filters = {
        organization_crop_field_code: "",
        producer_code: "",
        organization_producer_code: ""
      };
      this.filtered = false;
      this.fetchProducers();
    },
    certificationLabel(field_certifications, certification_id) {
      let field_certification = field_certifications.find(
        (provider_cert) => provider_cert.certification_id == certification_id
      );
      if (field_certification) {
        let data = [];
        let days = this.daysUntilExpirationDate(
          field_certification.expiration_date
        );
        data[0] = days;
        if (field_certification.suspended) {
          data[1] = this.$t("model.crop_field_certification.suspended");
        }
        return data;
      }
      return [];
    },
    fillColumnsDef() {
      this.columnDefs = [
        {
          headerName: this.$t(
            "model.producer.organization_producer.producer_code"
          ),
          field: "organization_producer_code",
          filter: true,
          resizable: true,
          width: 400,
          cellRendererSelector: (params) => {
            return {
              component: GoToLink,
              params: {
                text: params.value,
                path_name: params.data.route,
                params_path: params.data.route_params,
              },
            };
          },
        },
        {
          headerName: this.$t("model.producer.producer_code"),
          field: "producer_code",
          filter: true,
          resizable: true,
          width: 400,
          cellRendererSelector: (params) => {
            return {
              component: GoToLink,
              params: {
                text: params.value,
                path_name: params.data.route,
                params_path: params.data.route_params,
              },
            };
          },
        },
        {
          headerName: this.$t("model.producer.lastname"),
          field: "lastname",
          filter: true,
          resizable: true,
          width: 400,
          cellRendererSelector: (params) => {
            return {
              component: GoToLink,
              params: {
                text: params.value,
                path_name: params.data.route,
                params_path: params.data.route_params,
              },
            };
          },
        },
        {
          headerName: this.$t("model.producer.name"),
          field: "name",
          filter: true,
          resizable: true,
          width: 400,
          cellRendererSelector: (params) => {
            return {
              component: GoToLink,
              params: {
                text: params.value,
                path_name: params.data.route,
                params_path: params.data.route_params,
              },
            };
          },
        },
        {
          headerName: this.$t("model.crop_field.self"),
          field: "crop_field",
          filter: true,
          resizable: true,
          width: 400,
        },
        ...this.certifications.map((cert) => {
          return {
            headerName: cert.name,
            field: `${cert.id}`,
            filter: true,
            cellRendererSelector: (params) => {
              return {
                component: LabelCertification,
                params: {
                  crop_field_certification: params.value,
                },
              };
            },
          };
        }),
      ];
    },
    goToShowOrganization(organization_id) {
      this.$router.push({
        name: this.routeName("show_organization"),
        params: {
          organization_id: organization_id,
        },
      });
    },
    goToShowPackingHouse(packing_house_id) {
      this.$router.push({
        name: this.routeName("show_packing_house"),
        params: {
          organization_id: this.organization_id,
          packing_house_id: packing_house_id,
        },
      });
    },
    daysUntilExpirationDate(expiration_date) {
      return moment(expiration_date).diff(moment.now(), "days");
    },
    sizeToFit() {
      this.gridApi.sizeColumnsToFit({
        defaultMinWidth: 250,
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    },
  },
};
</script>
